export const SHARED_ROUTES = {
  OPPORTUNITIES: "/opportunities",
  NEGOTIATE: {
    TERMS: "/opportunities/[opportunityId]/negotiate/terms",
    REVIEW: "/opportunities/[opportunityId]/negotiate/review",
  },
  OPPORTUNITY: "/opportunities/[opportunityId]",
  DEALS: "/deals",
  DEAL: {
    FINANCIAL_SUMMARY: "/deals/[purchaseOfferId]/financial-summary",
  },
  CANCEL_DEAL: {
    FORM: "/deals/[purchaseOfferId]/cancel-deal/form",
    CONTRACT: "/deals/[purchaseOfferId]/cancel-deal/contract",
    SIGN_CONTRACT: "/deals/[purchaseOfferId]/cancel-deal/sign-contract",
    CONFIRMATION: "/deals/[purchaseOfferId]/cancel-deal/confirmation",
  },
  AMENDMENT_REQUEST: {
    FORM: "/deals/[purchaseOfferId]/amendment-request",
    CONTRACT: "/deals/[purchaseOfferId]/amendment-request/contract",
  },
  CHAT: "/chat",
  ERROR: "/error",
};

export const BUYER_ROUTES = {
  INVITE_SELLER: {
    OFFER_DETAILS: "/opportunities/invite-seller/offer-details",
    TERMS: "/opportunities/invite-seller/terms",
    CONDITIONS: "/opportunities/invite-seller/conditions",
    INCLUSIONS_EXCLUSIONS: "/opportunities/invite-seller/inclusions-exclusions",
    REVIEW: "/opportunities/invite-seller/review",
  },
};

export const SELLER_ROUTES = {
  CREATE_LISTING: {
    REVIEW: "/listings/review",
    PROPERTY: {
      BASE: "/listings/property",
      FEATURES: "/listings/property/features",
    },
    ID_VERIFICATION: {
      CONSENT: "/listings/review/consent",
      OVERVIEW: "/listings/review/id-verification",
    },
    OWNERSHIP: {
      OVERVIEW: "/listings/ownership",
      TERMS_CONDITIONS: "/listings/ownership/terms-conditions",
      OWNER_DETAILS: "/listings/ownership/add-owners",
      OWNERSHIP_PROOF: "/listings/ownership/ownership-proof",
    },
    DECLARATIONS: {
      OVERVIEW: "/listings/declarations",
      PAGE_ONE: "/listings/declarations/1",
      PAGE_TWO: "/listings/declarations/2",
      PAGE_THREE: "/listings/declarations/3",
    },
    CONTRACT: {
      TERMS_CONDITIONS: "/listings/contract/terms-conditions",
    },
    PAYMENT: {
      SUBSCRIPTION: "/listings/payment/subscription",
      SUCCESS: "/listings/payment/success",
    },
    SUBMIT_ACTIVE_LISTING_CHANGES: "/listings/submit-active-listing-changes",
  },
  LISTINGS: "/listings",
  LISTING: "/listings/[propertyId]",
};

export const MARKETPLACE_ROUTES = {
  HOME: "/",
};

export const APP_ROUTES = {
  PROFILE: "/profile",
  APPOINTMENTS: "/appointments",
  REDIRECT: "/redirect",
  LOGIN: "/login",
  RSVP_TO_OPEN_HOUSE: "/appointments/rsvp-to-open-house",
  SUBMIT_APPOINTMENT_REQUEST: "/appointments/submit-appointment-request",
};
